import React from 'react';
import '../../common/SubNavbar.css'
import '../../common/CommonText.css'

const DownloadLabel = () => {
  return (
    <svg className='navbar-download-icon' width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.2">
          <path d="M14 23.3333L20.2222 17.1111L18.0444 14.9333L15.5556 17.4222V10.8889H12.4444V17.4222L9.95555 14.9333L7.77778 17.1111L14 23.3333ZM0 28V4.35556L3.57778 0H24.4222L28 4.35556V28H0ZM3.73333 4.66667H24.2667L22.9444 3.11111H5.05556L3.73333 4.66667Z" fill="#DFA226"/>
      </g>
    </svg>
  );
};

export default DownloadLabel;

